import { useZustandLocation } from "@faire/retailer-visitor-shared/app/_lib/routing/useZustandLocation";
import { useSearchPageQueryParams } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageQueryParams";
export var useSearchPageProductSearchString = function() {
    var pathname = useZustandLocation(function(state) {
        return state.pathname;
    }).pathname;
    var query = useSearchPageQueryParams().searchQuery;
    return pathname.startsWith("/brand") ? "" : query;
};
